<template>
  <div class="in-grid-banner">
    <div class="in-grid-banner__media">
      <template v-if="isMobile">
        <video-player
          v-if="banner.mediaMobile?.mediaType==='video'"
          class="in-grid-banner__mobile-video"
          :attributes="{
            autoplay: true,
            mute: true
          }"
          :image="banner.mediaMobile?.preview_image"
          :loaded-animation="false"
          :ratio="false"
          :intersection-observer="{
            enable: true,
          }"
          sizes="100vw"
          :sources="banner.mediaMobile?.sources"
        />

        <responsive-image
          v-else-if="banner.mediaMobile?.mediaType==='image'"
          class="in-grid-banner__mobile-image"
          :image="banner.mediaMobile?.image"
          :ratio="false"
          :padding="false"
          :loaded-animation="false"
        />
      </template>

      <template v-else>
        <video-player
          v-if="banner.mediaDesktop?.mediaType==='video'"
          class="in-grid-banner__desktop-video"
          :attributes="{
            autoplay: true,
            mute: true
          }"
          :image="banner.mediaDesktop?.preview_image"
          :loaded-animation="false"
          :ratio="false"
          :intersection-observer="{
            enable: true,
          }"
          sizes="100vw"
          :sources="banner.mediaDesktop?.sources"
        />

        <responsive-image
          v-else-if="banner.mediaDesktop?.mediaType==='image'"
          class="in-grid-banner__desktop-image"
          :image="banner.mediaDesktop?.image"
          :ratio="false"
          :padding="false"
          :loaded-animation="false"
        />
      </template>
    </div>

    <component
      :is="banner.ctaURL?.length ? 'a' : 'div'"
      class="in-grid-banner__content"
      :href="banner.ctaURL"
    >
      <p
        v-if="banner.subheading?.length"
        class="text-other-label-s in-grid-banner__subheading"
        v-text="banner.subheading"
      />

      <p
        v-if="banner.title?.length"
        class="text-heading-3xl in-grid-banner__title"
        v-text="banner.title"
      />

      <btn
        v-if="banner.ctaText?.length && banner.ctaURL?.length"
        class="in-grid-banner__cta"
        type=""
        modifiers="primary dark block center"
        :label="banner.ctaText"
        :url="banner.ctaURL"
      />
    </component>
  </div>
</template>

<script>

/**
 * Vue: In-Grid banner (in-grid-banner)
 * -----------------------------------------------------------------------------
 * Content banner displayed in PLP grid.
 * - Component settings: snippet / dynamic / async / scroll
 *
 */
import { mapState } from 'vuex'

import Btn from '~global/btn/btn'
import ResponsiveImage from '~global/images/responsive-image'
import VideoPlayer from '~async/video-player/video-player'

export default {
  name: 'InGridBanner',

  components: {
    Btn,
    ResponsiveImage,
    VideoPlayer,
  },

  props: {
    banner: {
      type: Object,
      default: () => ({
        title: '',
        subheading: '',
        mediaDesktop: null,
        mediaMobile: null,
        ctaText: '',
        ctaURL: '',
      }),
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },
}
</script>

<style lang="scss">
@import './in-grid-banner';
</style>
